<script lang="ts">
export interface ConfirmDialogProps {
  title: string
  confirmLabel: string
  loading?: boolean
}
</script>

<script setup lang="ts">
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline'
import ActionDialog from '../ActionDialog.vue'

const props = defineProps<ConfirmDialogProps>()

const emit = defineEmits<{
  confirm: []
}>()

const open = defineModel<boolean>('open', { default: false })
</script>

<template>
  <ActionDialog
    v-model:open="open"
    :title="props.title"
    :confirm-label="props.confirmLabel"
    confirm-variant="default"
    :loading="props.loading"
    @confirm="emit('confirm')"
  >
    <template #icon>
      <ExclamationCircleIcon class="text-accent" aria-hidden="true" />
    </template>
    <slot />
  </ActionDialog>
</template>
